export default "__VITE_ASSET__3bfa204b__"